<template>
  <div class="app-container">
    <div class="flex">
      <el-row gutter="10">
        <el-col span="6">
          <el-card style="margin-right: 16px">
            <div slot="header">
              <span>个人信息</span>
            </div>
            <div class="user_boxs">
              <div class="img_name">
                <img src="@/assets/user.png" />
                <p class="name">{{ user.nickName }}</p>
              </div>
              <div class="text_list">
                <div class="list">
                  <p class="title">手机号码</p>
                  <p class="text">{{ user.phonenumber }}</p>
                </div>
                <div class="list">
                  <p class="title">用户邮箱</p>
                  <p class="text">{{ user.email }}</p>
                </div>
                <div class="list" v-if="user.dept">
                  <p class="title">所属部门</p>
                  <p class="text">{{ user.dept.deptName }} / {{ postGroup }}</p>
                </div>
                <div class="list">
                  <p class="title">所属角色</p>
                  <p class="text">{{ roleGroup }}</p>
                </div>
                <div class="list">
                  <p class="title">创建日期</p>
                  <p class="text">
                    {{ parseTime(user.createTime, '{y}-{m}-{d} {h}:{i}') }}
                  </p>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>

        <el-col span="18">
          <el-card class="flex-grow">
            <el-tabs v-model="activeTab">
              <el-tab-pane label="基本资料" name="userinfo">
                <userInfo :user="userInfoData" @getUser="getUser" />
              </el-tab-pane>
              <el-tab-pane label="修改密码" name="resetPwd">
                <resetPwd :userId="user.userId" />
              </el-tab-pane>
            </el-tabs>
          </el-card>
        </el-col>

      </el-row>



    </div>
  </div>
</template>

<script>
import userInfo from './userInfo'
import resetPwd from './resetPwd'
import { getUserProfile } from '@/api/system/user'

export default {
  name: 'Profile',
  components: { userInfo, resetPwd },
  data() {
    return {
      user: {},
      passWordData: {},
      userInfoData: {},
      roleGroup: {},
      postGroup: {},
      activeTab: 'userinfo'
    }
  },
  created() {
    this.getUser()
  },
  methods: {
    getUser() {
      getUserProfile().then((response) => {
        this.user = response.data.user
        this.userInfoData = {
          nickName: this.user.nickName,
          email: this.user.email,
          phonenumber: this.user.phonenumber,
          sex: this.user.sex,
          userId: this.user.userId
        }
        this.passWordData = {
          userId: this.user.userId
        }
        this.roleGroup = response.data.roleGroup
        this.postGroup = response.data.postGroup
      })
    }
  }
}
</script>

<style scoped>
::v-deep .el-card__header {
  padding: 14px 20px;
}
</style>
